import { accessAtLeastManager } from 'charts/common/access';
import { InspectionTranslationKeys } from 'intl/keys';
import { useGetChart } from 'charts/common/hooks';
import { useMemo } from 'react';
import {
  ChartAxisSeriesItem,
  ChartType,
  InspectionChart,
  InspectionEvolutionFilters,
} from 'shared/types/analytics';
import type { ChartRuntime } from 'views/analytics/types';
import { useInspectionEvolutionFilters } from './filters';
import { buildInspectionEvolutionRawData } from './model';
import { EMPTY_CHART_RAW_DATA } from 'charts/model/mapSeriesToRawData';
import { useIntl } from 'react-intl';
import { useProjectTimezone } from 'store/project';

const EMPTY_EVOLUTION_SERIES: [ChartAxisSeriesItem, ChartAxisSeriesItem] = [
  { data: [], labels: [] },
  { data: [] },
];

export function useInspectionEvolution(): ChartRuntime<InspectionEvolutionFilters> {
  const intl = useIntl();
  const timezone = useProjectTimezone();
  const filters = useInspectionEvolutionFilters();
  const { series, loading, load, reload, updatedAt } = useGetChart({ chart: InspectionChart.inspectionEvolution, filters, initialSeries: EMPTY_EVOLUTION_SERIES });

  const rawData = useMemo(() => {
    if (!filters) {
      return EMPTY_CHART_RAW_DATA;
    }
    return buildInspectionEvolutionRawData(series, filters, intl, timezone);
  }, [series, filters, intl, timezone]);

  return {
    filters,
    titleId: InspectionTranslationKeys.evolutionChart,
    chartType: ChartType.line,
    canAccess: accessAtLeastManager,
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
